import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './AuthPages.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(username, password);
      
      // 토큰 만료로 저장된 페이지가 있으면 해당 페이지로 복귀
      const redirectPath = sessionStorage.getItem('redirectAfterLogin');
      if (redirectPath) {
        sessionStorage.removeItem('redirectAfterLogin');
        navigate(redirectPath);
      } else {
        navigate('/feed');
      }
    } catch (err) {
      setError(
        err.response?.data?.message || 
        '로그인에 실패했습니다. 사용자명과 비밀번호를 확인해주세요.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1 className="auth-title">Renew World</h1>
        <p className="auth-subtitle">사진과 영상을 공유하세요</p>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="error-message">{error}</div>}

          <input
            type="text"
            placeholder="사용자명 (ID)"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            className="auth-input"
            autoComplete="username"
          />

          <input
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="auth-input"
            autoComplete="current-password"
          />

          <button 
            type="submit" 
            disabled={loading}
            className="auth-button"
          >
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <div className="auth-link">
          계정이 없으신가요?{' '}
          <Link to="/signup" className="link">
            회원가입
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;

